import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { authAPI } from '../services/api'

const useAuthStore = create(
  persist(
    (set, get) => ({
      // Estado
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      // Ações
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      
      setToken: (token) => set({ token }),
      
      setLoading: (isLoading) => set({ isLoading }),
      
      setError: (error) => set({ error }),
      
      clearError: () => set({ error: null }),

      // Login
      login: async (stellarAccountId, publicKey) => {
        try {
          set({ isLoading: true, error: null })
          
          const response = await authAPI.login(stellarAccountId, publicKey)
          const { access_token } = response.data
          
          // Salvar token
          set({ token: access_token })
          
          // Obter dados do usuário
          const userResponse = await authAPI.getCurrentUser(access_token)
          set({ 
            user: userResponse.data, 
            isAuthenticated: true,
            isLoading: false 
          })
          
          return { success: true }
        } catch (error) {
          const errorMessage = error.response?.data?.detail || 'Erro ao fazer login'
          set({ 
            error: errorMessage, 
            isLoading: false,
            isAuthenticated: false 
          })
          return { success: false, error: errorMessage }
        }
      },

      // Registro
      register: async (userData) => {
        try {
          set({ isLoading: true, error: null })
          
          const response = await authAPI.register(userData)
          const user = response.data
          
          set({ 
            user, 
            isAuthenticated: true,
            isLoading: false 
          })
          
          return { success: true, user }
        } catch (error) {
          const errorMessage = error.response?.data?.detail || 'Erro ao registrar'
          set({ 
            error: errorMessage, 
            isLoading: false,
            isAuthenticated: false 
          })
          return { success: false, error: errorMessage }
        }
      },

      // Logout
      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null
        })
      },

      // Verificar autenticação
      checkAuth: async () => {
        const { token } = get()
        if (!token) {
          set({ isAuthenticated: false, isLoading: false })
          return
        }

        try {
          set({ isLoading: true })
          const response = await authAPI.getCurrentUser(token)
          set({ 
            user: response.data, 
            isAuthenticated: true,
            isLoading: false 
          })
        } catch (error) {
          set({ 
            user: null,
            token: null,
            isAuthenticated: false,
            isLoading: false 
          })
        }
      },

      // Atualizar perfil
      updateProfile: async (profileData) => {
        try {
          set({ isLoading: true, error: null })
          
          const { token } = get()
          const response = await authAPI.updateProfile(profileData, token)
          
          set({ 
            user: response.data,
            isLoading: false 
          })
          
          return { success: true }
        } catch (error) {
          const errorMessage = error.response?.data?.detail || 'Erro ao atualizar perfil'
          set({ 
            error: errorMessage, 
            isLoading: false 
          })
          return { success: false, error: errorMessage }
        }
      },

      // Verificar conta Stellar
      verifyStellarAccount: async (publicKey) => {
        try {
          const response = await authAPI.verifyStellarAccount(publicKey)
          return { success: true, data: response.data }
        } catch (error) {
          const errorMessage = error.response?.data?.detail || 'Erro ao verificar conta Stellar'
          return { success: false, error: errorMessage }
        }
      }
    }),
    {
      name: 'connectus-auth',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token, 
        isAuthenticated: state.isAuthenticated 
      }),
    }
  )
)

export { useAuthStore }

















